import styles from "./Navigation.module.less";

import HeaderLink from "shared/components/HeaderLink";
import { Themes } from "shared/lib/theme";

interface Props {
  theme?: Themes;
  isFooter?: boolean
}

function Navigation({ theme = Themes.light, isFooter = false }: Props) {
  return (
      <div className={styles.navigation}>
          <HeaderLink title="Главная" to="/" theme={theme}/>
          <HeaderLink title="О нас" to="/about" theme={theme}/>
          <HeaderLink title="Купить билет" href="/ticket/concert" theme={theme}/>
          <HeaderLink title="Аккредитация" to="/akk" theme={theme}/>
          <HeaderLink title="Архив" to="/our-events" theme={theme}/>
          <HeaderLink title="Контакты" to="/contacts" theme={theme}/>
          { isFooter &&
              (
                  <div style={{width: '100%'}} className={styles.navigation}>
                      <HeaderLink title="публичная оферта"
                                  href="https://drivegrup.ru/ticket/uploads/files/oferta_drivegrup.pdf" theme={theme}/>
                      <HeaderLink title="политика обработки персональных данных"
                                  href="https://drivegrup.ru/ticket/uploads/files/policy_drivegrup.pdf?3" theme={theme}/>
                  </div>
              )
          }

      </div>
  );
}

export default Navigation;

